import server from "../../src/api/server";
import { useIntl } from "react-intl";
import styles from "@/styles/projects.module.scss";
import SinglePersonnel from "@/src/components/SinglePersonnel";

import BreadCrumb from "@/src/components/Shared/BreadCrumbs";
import { checkRedirect } from "@/src/components/helpers/functions";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { buildSeoAlternates } from "@/src/components/helpers/seo";

const ProjectsPage = ({ personnelData }) => {
  const { formatMessage } = useIntl();
  const { asPath, locale } = useRouter();
  const { canonical, languageAlternates } = buildSeoAlternates(asPath, locale);

  return (
    <>
      <NextSeo
        title={personnelData?.data?.personnel?.name?.ar}
        description={personnelData?.data?.personnel?.description?.ar}
        canonical={canonical}
        languageAlternates={languageAlternates}
      />
      <div className={styles.projectsPage}>
        <BreadCrumb
          heading={formatMessage({ id: "personnel" })}
          description={`${formatMessage({
            id: "main",
          })} / ${formatMessage({
            id: "personnel",
          })} / ${personnelData?.data?.personnel?.name?.ar}`}
          background={personnelData?.breadCrumbImage}
        />
        <div className="wrapper">
          <div className="projects-body category-id">
            <SinglePersonnel
              person={personnelData?.data?.personnel}
              countries={personnelData?.countries}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export async function getServerSideProps(ctx) {
  const { id } = ctx.params;
  const redirect = await checkRedirect(ctx.resolvedUrl, ctx.req);
  if (redirect) return { redirect };

  try {
    const personnelResponse = await server.get(`/personnels/${id}`);
    const homeResponse = await server.get("/pages/home");
    const countriesResponse = await server.get("/countries");

    const sectionData = (r) => r?.data?.data?.page?.sections || [];
    const homeData = (section) =>
      sectionData(homeResponse)?.filter((e) => e?.slug == section)?.[0] || [];

    return {
      props: {
        personnelData: {
          ...personnelResponse.data,
          breadCurmbImage:
            homeData("intro")?.items?.[0]?.backgroundImage || null,
          countries: countriesResponse?.data?.data?.countries || [],
        },
      },
    };
  } catch (error) {
    // Log the error or send to Sentry/etc.
    console.error(
      "Failed to fetch personnel:",
      error?.response?.status || error.message,
    );

    // Return 404 page
    return {
      notFound: true,
    };
  }
}

export default ProjectsPage;
